import rocket_icon from "@/assets/icons/become-dealer/rocket-circle.svg?react";
import cube_icon from "@/assets/icons/become-dealer/cube-circle.svg?react";

import check_badge_iconUrl from "@/assets/icons/become-dealer/check-badge.svg";
import sparkles_iconUrl from "@/assets/icons/become-dealer/sparkles.svg";
import shield_iconUrl from "@/assets/icons/become-dealer/shield-check.svg";
import star_iconUrl from "@/assets/icons/become-dealer/star.svg";

export const becomeDealerData = [
  {
    title: "Become an Installer",
    description:
      "Fill out our contact form with your company information and best contact.",
    Icon: rocket_icon,
  },
  {
    title: "Download the TrackmateGPS app",
    description: "",
    Icon: cube_icon,
  },
];

export const collaborationData = [
  {
    label: "Future-proof solutions scalable to your needs",
    iconUrl: check_badge_iconUrl,
  },
  {
    label: "Attractive margins and incentives",
    iconUrl: sparkles_iconUrl,
  },
  {
    label: "Best-in-class customer service and support",
    iconUrl: shield_iconUrl,
  },
  {
    label: "Resources and training to ensure your success",
    iconUrl: star_iconUrl,
  },
];
